import { AuthorizationRequestEntityTypeEnum } from './authorization-request-entity-type-enum';

export class AuthorizationRequest {
  entityTypeId: AuthorizationRequestEntityTypeEnum;
  entityId: number;
}
